import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Button, Tabs, Tab } from '@mui/material';
import employeeApi from '../../components/common/employeeApi';

export default function StaffComplete() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState(0);
  const tabLabels = [
    { label: 'Overview', key: 'overview' },
    { label: 'Staff Confirmed', key: 'confirmed' },
    { label: 'Non-confirmed', key: 'nonconfirmed' },
  ];
  const grouped = {
    overview: rows,
    confirmed: rows.filter(r => r.staff_ad_fee_confirmed),
    nonconfirmed: rows.filter(r => !r.staff_ad_fee_confirmed),
  };

  useEffect(() => {
    setLoading(true);
    employeeApi.get('/properties/progress/staff/complete/')
      .then(res => {
        setRows(res.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load data');
        setLoading(false);
      });
  }, []);

  const handleConfirm = async (idx, progressId) => {
    try {
      await employeeApi.patch(`/properties/progress/${progressId}/staff-ad-fee-confirm/`);
      setRows(prev => prev.map((row, i) => i === idx ? { ...row, staff_ad_fee_confirmed: true } : row));
    } catch (e) {
      alert('Failed to confirm ad fee.');
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, borderRadius: 3, bgcolor: 'background.paper', mt: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', fontWeight: 700 }}>
        Completed Ad Fees (Staff)
      </Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        {tabLabels.map((t, i) => <Tab key={t.key} label={t.label + ` (${grouped[t.key].length})`} />)}
      </Tabs>
      <Box sx={{ mt: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : grouped[tabLabels[tab].key].length === 0 ? (
          <Typography color="text.secondary">No completed ad fees</Typography>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Ad Fee Completed Date</TableCell>
                  <TableCell>Student Email</TableCell>
                  <TableCell>Company Name</TableCell>
                  <TableCell>Property Title</TableCell>
                  <TableCell>Landlord Email</TableCell>
                  <TableCell>Ad Fee Status</TableCell>
                  <TableCell>Staff Confirm</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {grouped[tabLabels[tab].key].map((row, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{row.ad_fee_completed_at ? new Date(row.ad_fee_completed_at).toLocaleDateString() : '-'}</TableCell>
                    <TableCell>{row.user_email}</TableCell>
                    <TableCell>{row.company_name}</TableCell>
                    <TableCell>{row.rental_title}</TableCell>
                    <TableCell>{row.landlord_email || '-'}</TableCell>
                    <TableCell>
                      {row.ad_fee_given ? (
                        <span style={{ color: '#388e3c', fontWeight: 600 }}>Completed</span>
                      ) : (
                        <span style={{ color: '#f57c00', fontWeight: 600 }}>Pending</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {row.staff_ad_fee_confirmed ? (
                        <span style={{ color: '#388e3c', fontWeight: 600 }}>Confirmed</span>
                      ) : (
                        (tabLabels[tab].key === 'nonconfirmed' || tabLabels[tab].key === 'overview') ? (
                          <Button variant="outlined" size="small" sx={{ color: '#ff9800', borderColor: '#ff9800' }} onClick={() => handleConfirm(idx, row.id)}>
                            Confirm
                          </Button>
                        ) : (
                          <span style={{ color: '#f57c00', fontWeight: 600 }}>Pending</span>
                        )
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Paper>
  );
} 